import React from 'react'

const HomeSidebarIcon = ({ width = 19, height = 17, color = 'white' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 19 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.1889 5.9815L10.3389 0.381497C9.68887 -0.118503 8.78887 -0.118503 8.13887 0.331497L0.338873 5.6815C-0.0111269 5.9315 -0.111127 6.3815 0.138873 6.7315C0.388873 7.0815 0.838873 7.1815 1.18887 6.9315L2.23887 6.1815V12.3315C2.23887 14.6315 4.08887 16.4815 6.38887 16.4815H12.0889C14.3889 16.4815 16.2389 14.6315 16.2389 12.3315V6.4315L17.2889 7.1815C17.4389 7.2815 17.5889 7.3315 17.7389 7.3315C17.9889 7.3315 18.1889 7.2315 18.3389 7.0315C18.5889 6.6815 18.4889 6.2315 18.1889 5.9815ZM14.7389 12.3315C14.7389 13.7815 13.5389 14.9815 12.0889 14.9815H6.38887C4.93887 14.9815 3.73887 13.7815 3.73887 12.3315V5.1315L9.03887 1.5315C9.13887 1.4315 9.28887 1.4315 9.43887 1.5315L14.7389 5.3315V12.3315Z"
                fill={color}
            />
        </svg>
    )
}

export default HomeSidebarIcon

